import React from 'react';

import { HomePage } from '../components/home/home';
import { Layouts } from '../components/layouts/layouts';

export const Home = () => {
  return (
    <Layouts>
      <HomePage />
    </Layouts>
  )
}